import ProfileDetailCard from "./profileDetailCard"
export default ProfileDetailCard;
